import Api from "./api";
import OidcManager from "./oidcManager";



export interface Customer {
    name: string;
    key: string;
    preferredAccountingSystem?:number
}

export class CustomersApi extends Api {

    public constructor(oidc: OidcManager, address: string) {
        super(oidc, address)
    }

    save(command: Customer): JQueryPromise<Customer> {
        console.log("saveCustomer", command);
        return super.post("/api/customer", command);
    }

    load(): JQueryPromise<Customer> {
        return super.get("/api/customer",{});
    }
}


// WEBPACK FOOTER //
// ./ClientApp/services/api/customers.ts